var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMovoraArrow = function SvgMovoraArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Directional chevron")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m12.579 17.964-3.79-3.647A3.2 3.2 0 0 1 7.793 12a3.2 3.2 0 0 1 .996-2.317l3.79-3.647a.13.13 0 0 1 .18 0l1.208 1.162a.105.105 0 0 1 0 .153l-3.981 3.831-.045.05c-.22.212-.331.49-.332.768 0 .278.111.556.332.768l.03.035 3.996 3.846a.105.105 0 0 1 0 .153l-1.208 1.162a.13.13 0 0 1-.18 0"
  })));
};
export default SvgMovoraArrow;